# Tools, open data & internet infrastructure
https://data.gov
https://ourworldindata.org
https://gapminder.org
https://datahub.io
https://kaggle.com
https://huggingface.co
https://openstreetmap.org
https://overpass-turbo.eu
https://wunderground.com
https://windy.com
https://flightaware.com
https://marinetraffic.com
https://flightradar24.com
https://airvisual.com
https://openaq.org
https://crt.sh
https://shodan.io
https://haveibeenpwned.com
https://urlscan.io
https://web.archive.org
https://commoncrawl.org
https://opendatacommons.org
https://creativecommons.org
https://eff.org
https://aclu.org
https://torproject.org
https://proton.me
https://signal.org
https://matrix.org
https://element.io
https://joinmastodon.org
https://lemmy.world
https://kbin.social
https://peertube.tv
https://odysee.com
https://ipfs.tech
https://arweave.org
https://handshake.org
https://letsencrypt.org
https://ietf.org
https://w3.org
https://whatwg.org
https://icann.org
https://isoc.org
